<template>
  <div :style="{backgroundColor: $store.state.config.bg_color}">
    <router-view v-if="page_status"></router-view>
    <div v-else><not-found :height="not_height"></not-found></div>
  </div>
</template>

<script>
import { ajax } from 'jquery'
import NotFound from '@/pages/NotFound.vue'

export default {
  name: 'App',
  components: {
  	'not-found': NotFound
  },
  data() {
  	return{
  		page_status: true,
  		not_height: '100%'
  	}
  },
  created() {
  	let that = this;

		//路由配置
		that.$store.dispatch('checkHost', process.env.NODE_ENV);

  	//请求配置数据
		ajax({
			type: 'get',
			url: that.$store.state.Host+'/v/votes/'+that.$route.query.tt+'/config',
			success: function(res) {
				let config = {
					header: res.header,
					footer: res.footer,
					share: res.share,
					bg_color: res.bg_color,
					title_color: res.title_color,
					button_color: res.button_color,
					progress_color: res.progress_color,
					title: res.title,
					share_desc: res.share_desc,
					start_time: res.start_time,
					end_time: res.end_time
				};

				that.$store.dispatch('catchConfig', config);
				
				document.title = that.$store.state.config.title;
			},
			error: function(err, data) {
				if(err.status == 404) {
					setTimeout(function() {
						that.page_status = false;
						that.not_height = window.innerHeight + 'px';
					}, 3000);
					console.log('找不到');
				}
			}
		});

		//评论
		ajax({
			type: 'get',
			url: '/v/communications/?message_id='+that.$route.query.message_id,
			success: function(res) {
				that.$store.dispatch('getComment', res.communications);
				that.$store.dispatch('currentComment', that.$store.state.comment[0]);
			}
		});

  },
  mounted() {
  	let that = this;

  	//启动评论轮播
  	that.comment(that.$store.state.comment);
  },
  methods: {
    comment(data) {
    	let n = 0,
    			that = this;

      setInterval(function() {
        if(n == that.$store.state.comment.length) {
        	n = 0;
        }

      	that.$store.dispatch('currentComment', that.$store.state.comment[n]);
        n ++;
      }, 5000);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue